import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { router } from "./router";
import { useEffect } from "react";
import TagManager from "react-gtm-module";

const queryClient = new QueryClient();

export default function App() {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-NGSH7FH",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
  